import React from "react";
import moment from "moment";
import { ReactComponent as CircleIcon } from "./../../images/svg/circle.svg";
import { useLocation, useRouteMatch, Link } from "react-router-dom";

const AllStationsListItem = ({ sensor }) => {
  const location = useLocation();
  const match = useRouteMatch();

  var statusColor = "icon is-small text-red is-inline has-left-spacing";
  if (sensor.status === "new") {
    statusColor = "icon is-small text-gray is-inline has-left-spacing";
  } else if (sensor.status === "on") {
    statusColor = "icon is-small text-green is-inline has-left-spacing";
  } else if (sensor.status === "onNoData" || sensor.status === "offData") {
    statusColor = "icon is-small text-yellow is-inline has-left-spacing";
  }

  let sensorUrl = match.path + "/" + sensor.id + "/detail" + location.search;

  var now = moment();
  var sensorname = sensor.name;
  if (sensor.endDate && sensor.endDate.diff(now) < 0) {
    sensorname = sensor.startDate.year() + ": " + sensor.name;
  }

  var latestMeasurement = "";
  if (sensor.latestMeasurement) {
    var d = new Date(sensor.latestMeasurement * 1000);
    latestMeasurement = d.toLocaleDateString() + " " + d.toLocaleTimeString().substring(0, 5);
  }

  return (
    <tr>
      <td>
        <Link to={sensorUrl} title={sensor.serialNumber}>
          {sensorname}
          <CircleIcon className={statusColor} />
          <span className="type">{sensor.type}</span>
        </Link>
      </td>
      <td>{latestMeasurement}</td>
    </tr>
  );
};

export default AllStationsListItem;
